export default __webpack_public_path__ + "static/media/reorder-tone-nz.2de06c88.mp3";